import { useMemo } from 'react'
import getMaxAvailable from 'utils/getMaxAvailable'

function useMaxAvailable(item = {}) {
  return useMemo(() => {
    return getMaxAvailable(item)
  }, [
    item.item_type,
    item.item_qty,
    item.items_purchased,
    item.raffle_qty,
    item.tickets_purchased
  ])
}

export default useMaxAvailable



// WEBPACK FOOTER //
// ./src/hooks/useMaxAvailable.js